import React from 'react';

const SIZES = {
  small: 28,
  medium: 38,
  large: 52,
};

export default function Logo({ variant = 'full', size = 'medium' }) {
  const height = SIZES[size] || SIZES.medium;
  const src = variant === 'mark' ? '/favicon.svg' : '/logo.svg';
  return (
    <img
      src={src}
      alt="BRAGSHEET"
      style={{ height: `${height}px`, width: 'auto', display: 'block' }}
    />
  );
}
